import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import Helpers from "../../helpers/helpers";
import { deleteVoucher, exportVoucher, getVoucherListing, resetVoucherAttachmentState, resetVoucherState } from "../../store/actions";
import moment from 'moment';
import Label from "../../components/Common/Label";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../components/Common/DeleteModal.js";


const VoucherManagement = ({ title, userPermission, exportExcel, voucher, delVoucher }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [filterObject, setFilterObject] = useState({ status: 'all', discountType: 'all' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const searchRef = useRef(keyword);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const discountTypeList = [
        { value: "all", label: "All Discount Type" },
        { value: "1", label: "Percentage (%)" },
        { value: "0", label: "Fixed Amount Discount (S$)" },
    ]
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
            userPermission?.includes("export-marketing") && setExportable(true);
            !userPermission?.includes("view-marketing") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, length, sort, sort_by, filterObject]);

    useEffect(() => {
        if (delVoucher?.code === "success") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({ open: true, msg: "Voucher deleted successfully", type: "success" });
            dispatch(resetVoucherState());
            setPage('1');
            initData();
        }
    }, [delVoucher])

    useEffect(() => {
        if (exportExcel?.code === "success") {
            setIsLoading(false);
            Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'voucher_listing');
            dispatch(resetVoucherAttachmentState());
        }
    }, [exportExcel]);

    const initData = () => {
        dispatch(getVoucherListing({
            length: length,
            page: page,
            keyword: searchRef.current,
            sort: sort,
            sort_by: sort_by,
            status: filterObject?.status,
            discount_type: filterObject?.discountType
        }))
    }

    const getDiscountType = (data) => {
        if (data.discount_type === "shipping")
            return "Shipping"
        else if (data.discount_type === "product") {
            if (data.product_applicability_type === "products") {
                if (data.apply_to_all_product === 1)
                    return "All Product"
                else
                    return "Specific Product"
            } else if (data.product_applicability_type === "categories") {
                if (data.apply_to_all_category === 1)
                    return "All Categories"
                else
                    return "Specific Categories"
            }
        }
        return "-"
    }

    const header = [
        {
            Header: "Name",
            columnID: "name",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.name}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Points Required",
            columnID: "points_needed",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.points_needed}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Discount On",
            columnID: "product_applicability_type",
            accessor: (cellProps) => {
                return (<React.Fragment>
                    {getDiscountType(cellProps)}
                </React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Discount Value",
            columnID: "discount_value",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.is_percentage !== 1 && "S$"}{cellProps?.discount_value} {cellProps?.is_percentage === 1 && "%"} off</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Redeemable From",
            columnID: "start",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>{moment(cellProps?.start).format("DD MMM YYYY")}</React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Redeemable Until",
            columnID: "end",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>{cellProps?.end ? moment(cellProps?.end).format("DD MMM YYYY") : "-"}</React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Redemptions",
            columnID: "redemption_count",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.redemption_count}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Label.StatusLabel label={cellProps?.status === 1 ? "Active" : "Inactive"} marginLeft={"0px"} />
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <Link to={`/edit-voucher/${cellProps.id}`}>
                            <CustomIconButton
                                iconName={'ri-pencil-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                        <RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#ED1A3D',
                                permission: deletable,
                                onClick: () => { setDeleteOpen(true); setSelectedRow(cellProps) }
                            }]}
                        />
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
    };

    const resetFilter = () => {
        setPage("1");
        setFilterObject({ status: 'all', discountType: 'all' });
        setSearch('');
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const handleDelete = () => {
        if (selectedRow?.id) {
            setIsLoading(true);
            dispatch(deleteVoucher({ id: selectedRow.id }));
        }
    }

    const handleExport = () => {
        let filter = {
            status: filterObject?.status === 'all' ? '' : filterObject?.status,
            is_percentage: filterObject?.discountType === 'all' ? '' : filterObject?.discountType,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        dispatch(exportVoucher({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
        setIsLoading(true);
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={3} md={3} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.discountType || "0"}
                            onChange={(e) => { setPage("1"); handleFilterChange('discountType', e) }}
                            data={discountTypeList}
                            placeholder={"Discount type"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.status || "all"}
                            onChange={(e) => { setPage("1"); handleFilterChange('status', e) }}
                            data={Helpers.status}
                            placeholder={"Status"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    {exportable && <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                </Grid>
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header d-flex">Vouchers <div className="header-amount mx-2">{voucher?.total}</div></div>
                {creatable && <CustomButton
                    title={<div className="d-flex align-items-center"><i className="ri-add-fill me-1" />Add voucher</div>}
                    backgroundColor={'#101010'}
                    textColor={'white'}
                    press={() => navigate("/add-voucher")}
                />}
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !voucher?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={voucher && voucher?.data} pageSize={length}
                        totalPage={voucher && voucher?.last_page}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={voucher && voucher?.last_page}
                    />
                </Container>
            </div>
            <DeleteModal
                open={deleteOpen}
                close={() => setDeleteOpen(false)}
                submit={() => handleDelete()}
                module={'voucher'}
            />
        </React.Fragment >
    );
};

function mapStateToProps({ Voucher, Login, }) {
    return {
        voucher: Voucher.voucherListing,
        delVoucher: Voucher.deleteVoucher,
        userData: Login?.verifyAdmin?.user?.data,
        delCustArry: Voucher?.delVoucher,
        exportExcel: Voucher.exportVoucher,
        userPermission: Login.permissionArry,
    };
}

export default connect(mapStateToProps)(VoucherManagement);
